import { themed } from "@tamagui/helpers-icon";
import { memo } from "react";
import { Svg, Path } from "react-native-svg";

import type { IconProps } from "@tamagui/helpers-icon";
import type { NamedExoticComponent } from "react";

const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <Path
        d="M14 15C14.7956 15 15.5587 14.6839 16.1213 14.1213C16.6839 13.5587 17 12.7956 17 12C17 11.2044 16.6839 10.4413 16.1213 9.87868C15.5587 9.31607 14.7957 9 14 9M22 12H21M10 3L10 21M14 20V21M14 3V4M20.3601 5.64009L19.6601 6.34009M19.6601 17.6601L20.3601 18.3601M10 12L2 12M7 20L10 17M10 7L7 4M3 9L6 12L3 15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

Icon.displayName = "HVAC";

export const HVAC: NamedExoticComponent<IconProps> = memo<IconProps>(
  themed(Icon),
);
